import { FC, ReactNode } from 'react'

import { useQuery } from '@tanstack/react-query'
import { getRouteApi } from '@tanstack/react-router'
import { alertsReportQueryOptions } from '~bank-reports/service/alertsReportQueryOptions'

import { AlertsReportResponse } from '../types'
import { AlertsReportContext } from './reportContext'

export const AlertsReportContextProvider: FC<{
  children: ReactNode
}> = ({ children }) => {
  const routeApi = getRouteApi('/_app/reports/alerts')
  const search = routeApi.useSearch()

  const { data, isFetching } = useQuery<AlertsReportResponse>(alertsReportQueryOptions(search))

  if (!data) return null

  return <AlertsReportContext.Provider value={{ data, isFetching, routeApi }}>{children}</AlertsReportContext.Provider>
}
